export default "__VITE_ASSET__5ba3f1df__"